<template>
  <div>
    <spinner v-if="showLoading && !events"/>

    <div v-if="message" class="alert alert-success alert-dismissible">
      <a href="#" class="close" @click="message=''">&times;</a>
      <b>Success!</b> {{ message }}
    </div>
    <div v-if="error" class="alert alert-warning alert-dismissible">
      <a href="#" class="close" @click="error=''">&times;</a>
      <b>Error!</b> {{ error }}
    </div>

    <br/>
    <full-calendar
      @event-drop="dropEvent"
      @event-resize="resizeEvent"
      @day-click="clickMethod"
      @event-selected="editEvent"
      :events="events"
      :config="config"
      ref="calendar"
    />

    <div class="modal fade right" id="event-modal" role="dialog" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">×</button>
            <h4 class="modal-title uppercase">{{ titleModal }}</h4></div>
          <div class="modal-body">
            <form>
              <div class="form-group" :class="{ 'has-error': validationErrors.Title }">
                <label for="title">Title</label>
                <vue-tribute :options="tributeOptions" @click="console">
                  <p class="form-control classic-form" id="event-title" contenteditable="true" @keyup="console"></p>
                </vue-tribute>
                <input id="title" class="form-control" name="Title" type="hidden" v-validate="'required'"
                       v-model="event.title">
                <span v-if="validationErrors.Title" class="help-block">
                  {{ validationErrors.Title[0] }}
                </span>
              </div>
              <div class="form-group" :class="{ 'has-error': errors.has('new-event-modal.All Day') }">
                <label for="all_day">All Day &nbsp;
                  <input id="all_day" name="All Day" type="checkbox" v-model="event.allDay">
                </label>

                <span v-show="errors.has('new-event-modal.All Day')" class="help-block">
                  {{ errors.first('new-event-modal.All Day') }}
                </span>
              </div>
              <div class="form-group" :class="{ 'has-error': errors.has('new-event-modal.Start') }">
                <label for="start">Start</label>
                <div>
                  <date-picker
                    id="start"
                    type="datetime"
                    v-model="event.startDateTime"
                    :format="calendarTimeFormat"
                    lang="en"
                    @confirm="setEnd"
                    confirm
                    :time-picker-options="{start: '00:00',step: '00:30',end: '23:30'}"
                    v-if="!event.allDay"
                    prefix-class="xmx"
                  >
                  </date-picker>
                  <date-picker
                    id="start"
                    type="date"
                    v-model="event.startDateTime"
                    :format="calendarFormat"
                    lang="en"
                    prefix-class="xmx"
                    confirm
                    v-else
                  >
                  </date-picker>
                </div>

                <span v-show="errors.has('new-event-modal.Start')" class="help-block">
                                    {{ errors.first('new-event-modal.Start') }}
                                </span>
              </div>
              <div v-if="!event.allDay" class="form-group" :class="{ 'has-error': errors.has('new-event-modal.End') }">
                <label for="end">End</label>
                <div>
                  <date-picker
                    id="end"
                    type="datetime"
                    v-model="event.endDateTime"
                    :format="calendarTimeFormat"
                    lang="en"
                    prefix-class="xmx"
                    confirm
                    :time-picker-options="{start: '00:00',step: '00:30',end: '23:30'}"
                  >
                  </date-picker>
                </div>

                <span v-show="errors.has('new-event-modal.End')" class="help-block">
                                    {{ errors.first('new-event-modal.End') }}
                                </span>
              </div>
              <div class="form-group" :class="{ 'has-error': errors.has('new-event-modal.Comment') }">
                <label for="comment">Comments</label>
                <textarea id="comment" class="form-control" name="Comment" type="text"
                          v-model="event.comment"></textarea>
                <span v-show="errors.has('new-event-modal.Comment')" class="help-block">
                                    {{ errors.first('new-event-modal.Comment') }}
                                </span>
              </div>


            </form>
          </div>
          <div class="modal-footer">
            <button class="btn green mt-ladda-btn ladda-button add-form-btn"
                    @click.prevent="saveEvent()"
                    data-style="expand-left"
                    >
              <span class="ladda-label">Save</span>
            </button>

            <button class="btn green mt-ladda-btn ladda-button add-form-btn"
                    @click.prevent="cancelEvent()"
                    data-style="expand-left">
              <span class="ladda-label">Cancel</span>
            </button>

            <button v-if="event.id" class="btn green mt-ladda-btn ladda-button add-form-btn"
                    @click.prevent="deleteEvent()"
                    data-style="expand-left"
                    >
              <span class="ladda-label">Delete</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade right" id="event-modal-export" role="dialog" aria-hidden="true">
      <div class="modal-dialog modal-sm">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close pull-right" data-dismiss="modal" aria-hidden="true">×</button>
            <h4 class="modal-title uppercase">Export Events</h4>
            <div class="actions pull-right">
              <a class="btn btn-circle btn-icon-only btn-default" v-if="eventsExport.length > 0"
                 @click.prevent="exportEvent()">
                <i class="icon-cloud-download"></i>
              </a>
            </div>
          </div>
          <div class="modal-body">
            <form>
              <div class="form-group" v-if="!showLoading">
                <h5>Select Date Range</h5>
                <date-picker
                    v-model="dateRange"
                    placeholder="Select Date Range"
                    lang="en"
                    range-separator="-"
                    :format="calendarFormat"
                    :value-type="'format'"
                    :range="true"
                    :confirm="false"
                    prefix-class="xmx"
                />

                <br/><br/>
                <div v-for="event in eventsExport" class="form-group">
                  <div><b v-html="event.title"></b></div>
                  <div @click="editEvent(event)">{{ event.start_date_time }} - {{ event.end_date_time }}</div>
                  <hr>
                </div>

                <div v-if="eventsExport.length == 0">
                  No events available.
                </div>
                <pagination
                  :page-count="pages"
                  :initial-page="parseInt(page - 1)"
                  :page-range="1"
                  :margin-pages="1"
                  :click-handler="changePage"
                  :prev-text="'Prev'"
                  :next-text="'Next'"
                  :container-class="'pagination pagination-sm'">
                </pagination>
              </div>
              <spinner v-if="showLoading"/>
            </form>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>
<script>
  import Pagination from '@/components/Pagination';
  import DatePicker from 'vue2-datepicker';
  import {FullCalendar} from 'vue-full-calendar';
  import {HTTP, ERROR, URL, getUserInfo} from '@/http-common';
  import Spinner from '@/components/Spinner';
  import VueTribute from 'vue-tribute'


  export default {

    props: {
      type: {
        type: String,
        default: function () {
          return 'calendar'
        }
      },
    },

    data() {
      return {
        message: '',
        error: '',
        dateRange: null,
        shortcuts: [
          {
            text: 'Last 7 days',
            start: moment().subtract(7, 'd'),
            end: new Date()
          },
          {
            text: 'Last 30 days',
            start: moment().subtract(30, 'd'),
            end: new Date()
          },
          {
            text: 'Custom Range',
            start: new Date(),
            end: new Date()
          },
        ],

        titleModal: '',
        users: [],
        events: [],
        eventsExport: [],
        startDate: null,
        endDate: null,
        page: 1,
        pages: 1,

        currentUser: this.$route.params.id,

        validationErrors: [],

        event: {
          id: null,
          title: '',
          participant: null,
          allDay: false,
          startDateTime: new Date(),
          endDateTime: new Date(),
          comment: ''
        },
        showLoading: true,
        tributeOptions: {
          values:
            function (text, cb) {
            HTTP.post('/search', {keyword: text})
              .then(response => {
                ERROR(response);
                if (response.data.status == 'success') {
                  cb(response.data.data.rows);
                }
              })
              .catch(err => {
                console.log(err);
              });
          },
          lookup: 'participant_name',
          allowSpaces: true,
          selectTemplate: function (item) {
            return `<span contenteditable="false"><a class="participant-link" data-id="${item.original.id}">${item.original.participant_name}</a></span>`;
          },
          selectClass: 'highlight'
        },
      }
    },

    inject: {
      $validator: '$validator'
    },

    components: {
      Pagination,
      DatePicker,
      FullCalendar,
      VueTribute,
      Spinner
    },

    mounted() {
      this.getEvents();
      this.getUsers();
      this.startDate = '01/01/2016';
      this.endDate = moment().format(this.calendarFormat);
      this.getExportEvents();
      $('#event-modal').on('hidden.bs.modal', function () {
        $('#event-title').html('');
      });
    },

    computed: {
      config() {
        return {
          customButtons: {
            exportButton: {
              text: 'Export',
              click: () => {
                this.openModalExport();
              },
            }
          },
          droppable: false,
          editable: false,
          defaultView: this.type ==='calendar' ? 'month' : 'agendaDay',
          selectable: false,
          header: {
            left: 'prev,next today exportButton',
            center: 'title',
            right: 'month,agendaWeek,agendaDay'
          },
          timeFormat: 'hh:mm A',
          eventRender: function (event, element) {
            element.find('.fc-title').html(event.title);
          }
        }
      },

      clickMethod() {
        return this.type === 'calendar' ? this.createEvent : this.moveToCalendar;
      },

      calendarFormat() {
        return getUserInfo('date_format');
      },

      calendarTimeFormat() {
        return getUserInfo('date_format')+' hh:mm A';
      }
    },

    methods: {
      bindEvents() {
        const links = document.querySelectorAll('.participant-link');
        for (var i = 0; i < links.length; i++) {
          links[i].addEventListener("click", this.setParticipant);
        }
      },
      setParticipant(id) {
        this.$router.push({name: 'Dashboard Participant', params: {id: id.target.getAttribute('data-id')}});
      },
      moveToCalendar() {
        this.$router.push({name: 'Calendar'});
      },
      getUsers() {
        HTTP.get('/search')
          .then(response => {
            ERROR(response);
            if (response.data.status === 'success') {
              this.users = response.data.data.data;
            }
          })
          .catch(err => {
            console.log(err);
          });
      },

      console(el) {
        this.event.title = el.target.innerHTML;
        this.bindEvents();
      },

      getExportEvents() {
        this.showLoading = true;
        HTTP.post('/events/index-by-dates', {
          'page': this.page,
          'start_date': this.startDate,
          'end_date': this.endDate
        })
          .then(response => {
            ERROR(response);
            if (response.data.status = 'success') {
              this.eventsExport = [];
              this.eventsExport = response.data.data.data;
              this.pages = response.data.data.pages;
              this.showLoading = false;
            }
          })
          .catch(err => {
            console.log(err);
          });
      },

      getEvents() {
        this.showLoading = true;
        HTTP.post('/events/index', {
          'start_date': this.startDate,
          'end_date': this.endDate
        })
          .then(response => {
            ERROR(response);
            if (response.data.status === 'success') {
              this.events = response.data.data;
              this.showLoading = false;
            }
          })
          .catch(err => {
            console.log(err);
          });
      },

      openModal() {
        $('#event-modal').modal('show');
      },

      closeModal() {
        $('#event-modal').modal('hide');
      },

      openModalExport() {
        this.page = 1;
        this.pages = 1;
        this.dateRange = [];
        $('#event-modal-export').modal('show');
      },

      closeModalExport() {
        $('#event-modal-export').modal('hide');
      },

      deleteEvent() {
        this.showLoading = true;
        HTTP.post(`/events/delete`, {event_id: this.event.id})
          .then(response => {
            ERROR(response);
            if (response.data.status === 'success') {
              this.showLoading = false;
              this.message = 'Event deleted.';
              this.getEvents();
              this.closeModal();
            }
          })
          .catch(err => {
            console.log(err);
          });
      },

      changePage(page) {
        this.page = page;
        this.getExportEvents();
      },

      exportEvent() {
        this.showLoading = true;
        HTTP.post('/events/export', {
          'page': this.page,
          'start_date': this.startDate,
          'end_date': this.endDate
        })
          .then(response => {
            ERROR(response);
            this.showLoading = false;
            this.closeModalExport();

            let blob = new Blob([response.data], {type: 'application/csv'});
            let link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = 'Events.csv';
            link.click();
          })
          .catch(err => {
            console.log(err);
          });
      },

      dropEvent(event) {
      },

      resizeEvent(event) {
        this.event = {
          id: event.id,
          title: event.title,
          participant: event.participant_id,
          allDay: event.allDay,
          startDateTime: event.start_date_time,
          endDateTime: event.end.format(this.calendarTimeFormat),
          comment: event.comment
        };

        this.saveEvent();
      },

      saveEvent() {
        let request;
        this.showLoading = true;

        request = {
          title: $('#event-title').html(),
          all_day: (this.event.allDay) ? '1' : '0',
          participant_id: this.event.participant,
          start_date_time: moment(this.event.startDateTime).isValid() ? moment(this.event.startDateTime).format(this.calendarTimeFormat) : this.event.startDateTime,
          end_date_time: moment(this.event.endDateTime).isValid() ? moment(this.event.endDateTime).format(this.calendarTimeFormat) : this.event.endDateTime,
          comment: this.event.comment,
        };

        if (this.event.id) {
          request.id = this.event.id;
        }

        HTTP.post('/events/save', request)
          .then(response => {
            ERROR(response);
            if (response.data.status == 'success') {
              this.cancelDateRange();
              this.closeModal();
              this.validationErrors = [];
              this.message = this.event.id ? 'Event updated.' : 'Event created.';
            }
            if (response.data.status == 'error') {
              this.validationErrors = response.data.data;
            }
          })
          .catch(err => {
            console.log(err);
          });
      },

      createEvent(date, jsEvent, view) {

        Date.prototype.addHours = function (h) {
          this.setHours(this.getHours() + h);
          return this;
        };

        function EventTime(addHours) {
          let newDate = new Date(date.format('YYYY'), date.format('MM') - 1, date.format('DD'), '08');
          return newDate.addHours(addHours);
        }

        let startDate = date;

        if (view.type === 'month') {
          startDate = new EventTime(0);
        } else {
          startDate = new Date(date.format('YYYY'), date.format('MM') - 1, date.format('DD'), date.format('HH'), date.format('mm'));
        }

        var endDate = new Date(startDate);
        endDate.setTime(startDate.getTime() + (1 * 1000 * 60 * 60));

        this.closeModalExport();
        this.validationErrors = [];
        this.titleModal = 'Create event';
        this.event = {
          id: null,
          title: '',
          participant: null,
          allDay: false,
          startDateTime: startDate,
          endDateTime: endDate,
          comment: ''
        };
        $('#event-title').html('');
        this.openModal();
      },

      editEvent(event) {
        this.closeModalExport();
        this.validationErrors = [];
        this.showLoading = true;
        HTTP.post('/events/show', {event_id: event.id})
          .then(response => {
            ERROR(response);
            if (response.data.status === 'success') {
              this.showLoading = false;
              this.event = {
                id: response.data.data.id,
                title: response.data.data.title,
                participant: response.data.data.participant_id,
                allDay: response.data.data.all_day,
                startDateTime: this.getTime(response.data.data.start_date_time),
                endDateTime: this.getTime(response.data.data.end_date_time),
                comment: response.data.data.comment
              };
              $('#event-title').html(response.data.data.title);
              this.titleModal = 'Edit event';
              this.openModal();
              this.bindEvents();
            }
          })
          .catch(err => {
            console.log(err);
          });
      },

      getTime(date) {
        let d = moment(date);
        return new Date(d.format('YYYY'), d.format('MM') - 1, d.format('DD'), d.format('HH'), d.format('mm'));
      },

      setEnd(date) {
        let endDate = new Date(date);
        let startDate = new Date(date);
        endDate.setTime(startDate.getTime() + (1 * 1000 * 60 * 60));
        this.event['endDateTime'] = endDate;
      },

      cancelDateRange() {
        this.dateRange = null;
        this.page = 1;
        this.startDate = null;
        this.endDate = null;
        this.eventsExport = [];
        return this.getEvents();
      },

      cancelEvent() {
        this.event = {
          id: null,
          title: '',
          participant: null,
          allDay: false,
          startDateTime: null,
          endDateTime: null,
          comment: ''
        };

        this.closeModal();
      }
    },

    watch: {
      dateRange: function (val) {
        if (val !== null && val !== '' && val.length != 0) {
          this.dateRange[0] = moment(this.dateRange[0]).format(this.calendarFormat);
          this.dateRange[1] = moment(this.dateRange[1]).format(this.calendarFormat);
          this.page = 1;
          this.startDate = this.dateRange[0];
          this.endDate = this.dateRange[1];
          //this.getEvents();
          this.getExportEvents();
        }
        if (val == '' || val.length == 0) {
          this.page = 1;
          this.startDate = '01/01/2016';
          this.endDate = moment().add('years', 2).format(this.calendarFormat);
          this.getExportEvents();
        }
      },
      '$route.params.id': function () {
        this.currentUser = this.$route.params.id;
      }
    }

  }
</script>
<style scoped>
  @import '~fullcalendar/dist/fullcalendar.css';

  .modal.fade:not(.in).right .modal-dialog {
    -webkit-transform: translate3d(25%, 0, 0) !important;
    transform: translate3d(25%, 0, 0) !important;
  }

  .fc-day-grid .fc-day:hover, .fc-day-grid .fc-day-top:hover {
    background-color: #ddd;
    cursor: pointer;
  }

  #event-modal-export .modal-header button {
    margin-right: 10px;
  }

  #event-modal-export .modal-title {
    display: inline-block;
  }

  #event-modal-export .modal-sm {
    width: 400px;
  }

  #event-modal-export .modal-dialog {
    position: absolute;
    left: 70px;
  }

  #event-modal-export .actions {
    margin-right: 10px;
  }

  #event-modal-export .pagination {
    display: flex;
    justify-content: center;
  }
</style>

<style>
  .tribute-container {
    z-index: 999999 !important;
  }
</style>



// WEBPACK FOOTER //
// CalendarCRUD.vue?35c8b50e